import { render } from "./TestUCTimePicker.vue?vue&type=template&id=413a3d34"
import script from "./TestUCTimePicker.vue?vue&type=script&lang=js"
export * from "./TestUCTimePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__